const style = (theme) => ({
  root: {
    marginBottom: 100,
    [theme.mq.sm]: {
      marginBottom: 50,
    },
  },
  videoSection: {
    maxWidth: 1440,
    margin: '0 auto',
    padding: '0 60px',
    [theme.mq.sm]: {
      padding: '0 30px',
    },
  },
  heroImg: {
    maxWidth: 1440,
    margin: '0 auto',
    padding: '0 60px',
    '& > div': {
      height: 0,
      paddingBottom: '56.25%',
      position: 'relative',
      zIndex: 1,
      '& > div': {
        position: 'absolute',
      },
      '& iframe': {
        position: 'absolute',
        zIndex: 1,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      },
    },
    [theme.mq.sm]: {
      padding: '0 30px',
    },
  },
})

export default style
